import { render } from "./FieldsMental.vue?vue&type=template&id=0c055274"
import script from "./FieldsMental.vue?vue&type=script&lang=js"
export * from "./FieldsMental.vue?vue&type=script&lang=js"
script.render = render

export default script